export enum HitAreaType {
  None = 'None',
  Rectangle = 'Rectangle',
  Circle = 'Circle',
  Ellipse = 'Ellipse',
  Polygon = 'Polygon',
  RoundedRectangle = 'RoundedRectangle',
}

type NoneHitArea = {
  type: HitAreaType.None;
};

type RectangleHitArea = {
  type: HitAreaType.Rectangle;
  x: number;
  y: number;
  width: number;
  height: number;
};

type CircleHitArea = {
  type: HitAreaType.Circle;
  x: number;
  y: number;
  radius: number;
};

type EllipseHitArea = {
  type: HitAreaType.Ellipse;
  x: number;
  y: number;
  halfWidth: number;
  halfHeight: number;
};

type PolygonHitArea = {
  type: HitAreaType.Polygon;
  path: string;
};

type RoundedRectangleHitArea = {
  type: HitAreaType.RoundedRectangle;
  x: number;
  y: number;
  width: number;
  height: number;
  radius: number;
};

export type HitArea =
  | NoneHitArea
  | RectangleHitArea
  | CircleHitArea
  | EllipseHitArea
  | PolygonHitArea
  | RoundedRectangleHitArea;
